/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { defineComponent } from "vue";

export default defineComponent({
  methods: {
    formatDate(date: Date, mode?: string): string {
      return ("0" + date.getDate()).slice(-2) + "." + ("0" + (date.getMonth() + 1)).slice(-2) + "." + date.getFullYear();
    },
    // TODO implement different modes
    formatTime(date: Date, mode?: string): string {
      return ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
    }
  },
});

export interface DateMixinTypes {
  formatDate(date: Date, mode?: string): string;
  formatTime(date: Date, mode?: string): string;
}